// extracted by mini-css-extract-plugin
module.exports = {"reqP":"reminderDialog_reqP_1ER8y"};